/*eslint-env jquery*/
import React, { Component, useState } from 'react'
import { toastr } from 'react-redux-toastr'
import MySweetAlert from '../Shared/MySweetAlert'
import Loading from '../Shared/Loading'
import { personnelsService } from '../../_services/personnels.service'
import GenderSelect from '../Shared/GenderSelect'
import { FaPlus, FaMale, FaFemale } from 'react-icons/fa'
import { FiEdit } from 'react-icons/fi'
import { FiTrash2 } from 'react-icons/fi'
import { AiOutlineLoading, AiOutlineSave } from "react-icons/ai"
import config from '../../config'
import PersonnelTypeSelect from '../Shared/PersonnelTypeSelect'

// Import React Table
import matchSorter from 'match-sorter'
import ReactTable from "react-table"

import { Input } from 'antd'
import { Tabs, Tab } from 'react-bootstrap'

import { Formik, Field, getIn, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import ErrorPopUp from '../Shared/ErrorPopUp'

import ReactSelect from 'react-select'
import SimpleValue from 'react-select-simple-value'

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import DialogTitle from '@material-ui/core/DialogTitle';
import Fab from '@material-ui/core/Fab'
import { MdClose } from 'react-icons/md'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const Select = ({ options, value, ...props }) => (
  <SimpleValue options={options} value={value}>
    {simpleProps => <ReactSelect {...props} {...simpleProps} />}
  </SimpleValue>
);

const initialData = { gender: '', firstName: '', lastName: '', personnelType: 3, image: '' }

export class DataTable extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      initialItems: [],
      data: [],
      modal: false,
      modalHeading: '',
      loading: true,
      confirmDeleteShow: false,
      deleteItemIndex: 0,
      activeTab: 'material',
      model: initialData,
    }

    this.getData()
  }

  handleModalCreate = () => {
    this.setState({ modalHeading: 'ثبت پرسنل جدید', modal: true, model: initialData });
  }

  handleModalEdit = (e) => {
    let _model = this.state.data[e];
    this.setState({ modal: true, model: _model, modalHeading: 'ویرایش پرسنل "' + _model.fullName + '"' });
  }

  handleModalHide = (e) => {
    var evt = e || window.event; // IE compatibility
    if (evt.preventDefault) {
      evt.preventDefault();
    }
    this.setState({ modal: false });
  }

  handleSweetAlertHide = () => {
    this.setState({ confirmDeleteShow: false });
  }

  getData() {
    personnelsService.getAll(this.props.personnelType)
      .then((res) => {
        console.log(res.data)
        this.setState({ data: res.data, loading: false, isSubmitting: false, modal: false });
      })
      .catch((error) => {
        this.handleError(error)
      });
  };


  handleError(error) {
    this.setState({ loading: false });
    // // toastr.warning('مشکلی پیش آمد', error);
  }

  handleDelete = (e) => {
    let _model = this.state.data[e];

    this.setState({ confirmDeleteShow: true, model: _model });
  }

  handleConfirmDelete = () => {
    this.setState({ loading: true, confirmDeleteShow: false });

    personnelsService.delete(this.state.model.id)
      .then((res) => {
        toastr.success('حذف پرسنل', 'پرسنل با موفقیت حذف شد');
        this.getData();
      })
      .catch((error) => {
        this.handleError(error)
      });
  }

  handleSubmit = (values) => {
    this.setState({ loading: true });
    // console.log(JSON.stringify(values));
    // values["personnelType"] = this.props.personnelType;

    if (values.id) {

      personnelsService.edit(values.id, JSON.stringify(values))
        .then((res) => {

          toastr.success('ویرایش پرسنل', 'پرسنل "' + values.name + '" با موفقیت ویرایش شد');
          this.setState({ modal: false });
          this.getData();

        })
        .catch((error) => {
          this.handleError(error)
        });

    } else {
      console.log(JSON.stringify(values));
      personnelsService.add(JSON.stringify(values))
        .then((res) => {

          toastr.success('ثبت پرسنل جدید', 'پرسنل "' + res.data.name + '" با موفقیت ثبت شد');
          this.setState({ modal: false });
          this.getData();

        })
        .catch((error) => {
          this.handleError(error)
        });

    }
  }

  render() {

    const ValidationSchema = Yup.object().shape({
      gender: Yup.string().trim().required('جنسیت'),
      firstName: Yup.string().trim().required('نام'),
      lastName: Yup.string().trim().required('نام خانوادگی'),
      // measurementType: Yup.string().trim().required('واحد اندازه گیری'),
    });
    const { model, loading } = this.state;
    return (
      <div>

        <div className="row table-container" style={{ marginTop: 0 }}>
          <ReactTable
            data={this.state.data}
            filterable
            loading={loading}
            previousText='صفحه قبل'
            nextText='صفحه بعد'
            loadingText='در حال بارگذاری ...'
            noDataText='نتیجه ای یافت نشد'
            pageText='صفحه'
            ofText='از'
            rowsText='تعداد نمایش'

            defaultFilterMethod={(filter, row) =>
              String(row[filter.id]) === filter.value}
            columns={[
              {
                Header: "ردیف",
                id: "row",
                maxWidth: 50,
                filterable: false,
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                className: "numberFa",
                Cell: (row) => {
                  return row.index + 1;
                }
              },
              // {
              //   Header: 'تصویر',
              //   accessor: 'image',
              //   id: "image",
              //   width: 100,
              //   sortable: false,
              //   filterable: false,
              //   style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
              //   Cell: row => (
              //     <img style={{ width: 80, display: 'inline' }} alt='' src={config.uploadsUrl + 'wwwroot/' + row.original.image} />
              //   ),
              // },
              {
                Header: "جنسیت",
                accessor: "gender",
                id: "gender",
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ["gender"], threshold: matchSorter.rankings.CONTAINS }),
                filterAll: true,
                Filter: ({ onChange }) =>
                  <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />,
                Cell: row => (
                  row.original.gender === 0
                    ? <FaMale color="#97d2fb" size="30px" />
                    : row.original.gender === 1
                      ? <FaFemale color="#c48da6" size="30px" />
                      : ''
                )
              },
              {
                Header: "نام",
                accessor: "firstName",
                id: "firstName",
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ["firstName"], threshold: matchSorter.rankings.CONTAINS }),
                filterAll: true,
                Filter: ({ onChange }) =>
                  <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />
              },
              {
                Header: "نام خانوادگی",
                accessor: "lastName",
                id: "lastName",
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ["lastName"], threshold: matchSorter.rankings.CONTAINS }),
                filterAll: true,
                Filter: ({ onChange }) =>
                  <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />
              },
              {
                Header: "ویرایش",
                accessor: 'id',
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                sortable: false,
                // filterable: false,
                Filter: ({ filter, onChange }) =>
                  <a onClick={this.handleModalCreate} className="btn btn-primary react-table-add-btn" >
                    <span>
                      <FaPlus size="16px" />
                      افزودن پرسنل جدید
                    </span>
                  </a>,
                Cell: row => (
                  <div>
                    <a onClick={() => this.handleModalEdit(row.index)} data-index={row.index} className="btn btn-sm btn-simple btn-success bmd-ripple bmd-flat-btn" rel="tooltip" data-original-title="ویرایش"><FiEdit size="24px" /></a>

                    <a onClick={() => this.handleDelete(row.index)} data-index={row.index} className="btn btn-sm btn-simple btn-danger bmd-ripple bmd-flat-btn delete-btn" data-original-title="حذف" rel="tooltip"><FiTrash2 size="24px" /></a>
                  </div>
                )
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />

        </div>

        <Dialog
          open={this.state.modal}
          onClose={this.handleModalHide}
          TransitionComponent={Transition}
          scroll={'paper'}
          fullWidth={true}
          maxWidth="sm"
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description">
          <DialogTitle>
            <Fab color="secondary" aria-label="refresh" size="small" onClick={() => this.handleModalHide()} className="modal-close-btn">
              <MdClose size="20px" />
            </Fab>
            <span style={{ marginRight: 10 }}></span>
          </DialogTitle>
          <DialogContent dividers={true}
            style={{ overflowY: 'visible', minHeight: 225 }}
          >

            <Formik
              initialValues={model}
              onSubmit={(values, { setSubmitting }) => {
                // // console.log(values);
                this.handleSubmit(values)
              }}
              validationSchema={ValidationSchema}
            >
              {props => {
                const {
                  values,
                  touched,
                  errors,
                  isSubmitting,
                  handleChange,
                  handleBlur,
                  setFieldValue,
                  handleSubmit,
                } = props;
                return (

                  <div className="row" style={{ position: "relative" }}>
                    <div className="col-md-12">
                      <form onSubmit={handleSubmit}>

                        <div className="row">
                          <div className="form-inline">

                            <div className="col-sm-12">
                              <label>جنسیت</label>
                              <GenderSelect name="gender" value={values.gender} defaultValue={values.gender}
                                onChange={(val) => {
                                  setFieldValue('gender', val);
                                }}

                              />
                              <ErrorPopUp error={errors.gender} touched={touched.gender} type="select" />
                            </div>

                            <div className="col-sm-12">
                              <label>نام</label>
                              <Field type="text"

                                name="firstName"
                                className={getIn(touched, "firstName") ? getIn(errors, "firstName") ? "text-input has-error" : "text-input" : "text-input has-error"}
                              />
                              <ErrorMessage component={ErrorPopUp} name="firstName" />
                            </div>

                            <div className="col-sm-12">
                              <label>نام خانوادگی</label>
                              <Field type="text"

                                name="lastName"
                                className={getIn(touched, "lastName") ? getIn(errors, "lastName") ? "text-input has-error" : "text-input" : "text-input has-error"}
                              />
                              <ErrorMessage component={ErrorPopUp} name="lastName" />
                            </div>

                            <div className={"col-sm-12 " + (touched.personnelType && errors.personnelType && "has-error")}>
                              <label>نوع پرسنل</label>
                              <PersonnelTypeSelect name="userType" value={values.personnelType} defaultValue={values.personnelType}
                                onChange={(val) => {
                                  setFieldValue('personnelType', val);
                                }}

                              />
                              <ErrorPopUp error={errors.personnelType} touched={touched.personnelType} type="select" />
                            </div>

                            <div className="clearfix form-row"></div>

                            {/* <div className="col-md-12">
                              <label className="pull-right">تصویر</label>
                              <PicUploader label="تصویر"
                                value={'wwwroot/' + values.image}
                                defaultValue={'wwwroot/' + values.image}
                                onChange={(val) => {
                                  setFieldValue('image', val);
                                }}
                              />
                              <ErrorMessage component={ErrorPopUp} name="image" />
                            </div>
                            <div className="clearfix form-row"></div> */}

                            <div className="col-md-12">
                              <button type="submit" className={"icon button submit-btn " + (isSubmitting ? "isSubmitting" : "")} disabled={isSubmitting}>
                                {isSubmitting ?
                                  <AiOutlineLoading className="mdi-spin" size="22px" />
                                  :
                                  <AiOutlineSave size="22px" />
                                }ذخیره</button>
                            </div>
                            <div className="clearfix form-row"></div>

                          </div>
                        </div>


                      </form>
                    </div>
                  </div>

                );
              }}
            </Formik>

          </DialogContent>
        </Dialog >

        <MySweetAlert
          show={this.state.confirmDeleteShow}
          onCancel={this.handleSweetAlertHide}
          onConfirm={this.handleConfirmDelete}
          title={"آیا از حذف پرسنل [" + this.state.model.fullName + "] مطمئن هستید؟"}
        >
        </MySweetAlert>

      </div >
    );
  }
}


const Personnels = props => {
  const [activeTab, setActiveTab] = useState('personnels')

  return (

    <Tabs transition={false}
      id="controlled-tab-example"
      activeKey={activeTab}
      onSelect={activeTab => setActiveTab(activeTab)}
    >
      <Tab eventKey="personnels" title="مدیریت اطلاعات پرسنل">
        {activeTab === 'personnels' ?
          <DataTable personnelType={0} />
          : ''}
      </Tab>
    </Tabs>
  )
}
export default Personnels;